import "../styles/text.css"

const Faq = () => {
    return (
        <div className="faq">
        <h2> FAQ </h2>
        <br/>
        <br/>
        <br/>
        <b>¿Cómo funciona el proceso para ordenar un regalo en Beet?</b>
        <p>
        Puedes hacer tu pedido directamente en nuestro sitio web,
        eligiendo entre las opciones Ready-to-Gift. Y también puedes
        escribirnos al WA 7602-5162 para recibir asesoría. Una vez
        confirmado tu pedido y realizado el pago, preparamos tu regalo
        con mucho amor y lo enviamos a la dirección indicada.
        </p>
        <br/>

        <b>¿Puedo hacerle cambios a algún regalo que aparece en las opciones Ready-to-Gift?</b>
        <p>
        Sí. En caso desees reemplazar, eliminar o agregar algún
        producto a tu regalo, nos lo puedes notificar a través del WA y
        nos adaptamos a tus gustos y necesidades.
        Según los cambios requeridos, el precio del regalo puede variar.
        </p>
        <br/>

        <b>¿Puedo personalizar mi regalos y qué opciones tengo?</b>
        <p>Sí! Muchos de nuestros productos permite personalización,
        desde grabados, estampados, diseño de viñetas/sticker hechos a
        tu medida. El tiempo de preparación de un regalo con
        personalizaciones, puede tomar hasta 48 horas, según el detalle
        de que requiera tu pedido.
        </p>
        <br/>

        <b>¿Puedo armar mi propio regalo, desde cero?</b>
        <p>
        Of course! De hecho, ese es nuestro expertise y tarea favorita.
        Para esto, nos escribes al WA 7602-5162 dónde nos das
        contexto y detalles sobre la idea que tienes en mente y nosotros
        te asesoramos y diseñamos una propuesta de contenido que va
        de la mano con la ocasión, tu estilo y tu budget.
        O si ya tienes clara la combinación de productos que te gustaría
        para el regalo, nos lo indicas y te lo preparamos.
        </p>
        <br/>

        <b>¿Con cuánto tiempo de anticipación debo hacer mi pedido?</b>
        <p>
        Si haces la compra desde nuestro catálogo Ready-to-Ship antes
        de las 10:00 AM, puedes recibir tu regalo el mismo día. De lo
        contrario, la entrega en San Salvador (AMSS) se realiza dentro
        de las primeras 24 horas luego de realizado el pago. Para las
        entregas departamentales o los pedidos que conllevan
        personalizaciones tal como grabados láser, bordados o
        estampados en prendas, pueden demorar hasta 72 horas.
        </p>
        <br/>

        <b>¿Ofrecen entregas el mismo día?</b>
        <p>
        Sí. En el punto anterior hemos detallado información importante.
        Nuestra sugerencia es que si te URGE un regalo, nos contactes
        directamente al WA 7602-5162 y nos lo hagas saber para
        ponernos manos a la obra y darle prioridad a tu pedido. Somos
        muy flexibles y siempre buscamos la forma de cumplir con tus
        necesidades y exceder tus expectativas.
        </p>
        <br/>

        <b>¿Puedo comprar algún producto por individual?</b>
        <p>Por supuesto! Puedes comprarlo desde el sitio y si no lo ves
        reflejado en nuestra tienda en línea, siempre puedes escribirnos
        al WA 7602-5162 para enviarte disponibilidad y precios.
        </p>

        <br/>
        <b>¿Cuál es la cobertura de las entregas a domicilio y qué costo
        tiene este servicio de entrega?</b>
        <p>
        Realizamos entregas a todo el país, de lunes a viernes de 8:00
        AM a 5:30 PM. Para pedidos en zonas departamentales
        solicitamos realizarlos con al menos 72 horas de anticipación.
        Las entregas a domicilio en San Salvador (AMSS) tiene una tarifa
        de $3.99 y las departamentales desde $10 ya que éstas últimas
        pueden variar según el volumen del pedido.
        </p>
        <br/>

        <b>¿Puedo comprar desde el extranjero para enviar un regalo en
        El Salvador?</b>
        <p>
        Claro que sí! Podes hacer tu compra en línea con tus tarjetas de
        crédito o débito, o también contactarnos por WA 7602-5162 para
        solicitar tu link de pago. Nosotros nos encargamos de todo para
        que tu regalo llegue a tiempo y al lugar que desees.
        </p>
        <br/>

        <b>¿Cuáles son los métodos de pagos disponibles?</b>
        <p>Aceptamos pagos en línea con tarjeta de crédito o débito Visa o
        Mastercard, transferencias bancarias y link de pago BAC al
        contactarnos vía WA 7602-5162.
        En el caso de pedidos corporativos y pagos realizados por
        empresas, aceptamos cheques también.
        </p>
        <br/>

        <b>¿Puedo visitar su Atelier para ver las opciones en persona o
        para retirar mi pedido?</b>
        <p>
        Please do! Usualmente la mayoría de nuestros clientes optan por
        nuestra atención en línea ya que prefieren la comodidad de poder
        comprar todo con un click o desde sus teléfono. Pero claro que
        las puertas de nuestro Atelier están siempre abiertas para
        quienes quieran ver los productos en físico, armar sus propios
        regalos y/o retirar sus pedidos en nuestro local.
        </p>
        <br/>

        <b>¿Adónde están ubicados?</b>
        <p>Nuestro Atelier está en Alameda Manuel Enrique Araujo 212, CC
        Feria Rosa, local 105-C.
        Dentro del CC, busca el jardín central y justo enfrente de la
        Virgencita estamos nosotros, con el logo Beet en la puerta :)
        ¿Qué cuidados debo tener con productos como globos o
        alimentos dentro del regalo?
        Los globos con helio suelen tener una duración apróximada de 24
        a 48 horas según el ambiente. Recomendamos mantenerlos en
        interiores y alejados del calor. Si tu regalo incluye chocolates,
        alimentos frescos como quesos o embutidos u otros alimentos, te
        sugerimos mantener el regalo en un lugar fresco, no exponerlo al
        sol por tiempo prologando, procura entregarlo en corto tiempo y
        consumir los alimentos en el tiempo indicado en la descripción
        del producto.
        </p>
        <br/>

        <b>¿Cuál es su política de cambios, devoluciones o
        reembolsos?</b>
        <p>Puedes cancelar un pedido siempre y cuando no incluya
        personalización. Debes solicitar la cancelación al 7602-5162. Si
        un producto presenta defectos de fábrica, puedes solicitar cambio
        o reembolso dentro de los siguientes 15 días luego de realizada
        la compra, siempre y cuando esté en su empaque original y no
        presente daños por uso.
        En productos personalizados, Beet no se hace responsable por
        errores en los nombres, fechas o textos proporcionados por el
        cliente, al momento de la compra.
        </p>
        <br/>
        <b>He escuchado que tienen el servicio de Personal Shopper
        ¿cómo funciona?</b>
        <p>
        Cada vez son más los clientes que nos confían sus compras. El
        proceso es fácil, ágil y transparente.
        1. Nos compartes las especificaciones de lo que necesitas
        2. Validamos si lo venden localmente o si se debe mandar a
        traer del extranjero
        3. Te enviamos la cotización con el desglose del precio del
        producto, el porcentaje de la comisión que aplica y el
        estimado de tiempo de entrega. El porcentaje de comisión se
        define tomando en cuenta varios factores como el monto total
        de la compra a realizar, el peso/volumen del producto en
        mención, la cantidad de ítems, el tiempo y/o recursos
        invertidos para realizar la compra, etc.
        4. Por último, una vez aceptado y confirmado el servicio,
        procedemos a realizar la compra y entrega.
        </p>
        <br/>

        <b>¿Es verdad que aparte de ofrecer Gifts, hacen eventos?</b>
        <p>Sí. Diseñamos, planificamos y ejecutamos eventos Boutique, los
        cuales son de máximo 50 personas y con un alto detalle de
        personalización. Nuestro servicio de Event Planner incluye desde
        el diseño de la conceptualización, manejo del presupuesto,

        planificación al detalle, contratación de terceros, hasta la
        ejecución del mismo (montaje/servicio/desmontaje).
        </p>
        <br/>

        <b>¿Ofrecen servicio para empresas o regalos corporativos?</b>
        <p>
        Yes, es nuestro fuerte! Contamos con una amplia experiencias
        creando regalos empresariales, desde promocionales
        personalizados hasta obsequios bastante elaborados. Nos
        caracterizamos principalmente por nuestra creatividad, por la
        facilidad y agilidad del proceso, nuestra habilidad de acoplarnos a
        tu branding e imagen de marca, nuestra capacidad de producir
        altos volúmenes, en cortos tiempos y adaptarnos a tu budget y
        necesidades.
        Para proyectos especiales o mayores a $500, nos puedes
        contactar al 7602-5162 o al correo lucia@beetgifts.com
        </p>
        </div>
    );
}

export default Faq;